
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
    name: 'Header'
})
export default class extends Vue {
    @Prop({default: 'transparent'})readonly bgColor!: string
    @Prop({default: false})readonly isShowShow!: boolean
    private goIndex() {
        this.$jump('/index')
    }
}
